import { FunctionComponent, useState } from 'react';
import ProjectStart from 'src/assets/images/ProjectStart.png';

import {
    ServicesCard,
    ButtonContentBox,
    ButtonTextBox,
    ContentContainer,
    HeaderContainer,
    ThankYouTitle,
    ImageContainer,
    ProjectImage,
    BodyText,
    ButtonIconBox
} from './styled';

import { StyledButton } from '../styled';

const Thankyou: FunctionComponent<{
    projectName: string;
}> = ({ projectName }) => {
    const [isStartHovered, setStartIsHovered] = useState(false);

    return (
        <ServicesCard>
            <ContentContainer>
                <HeaderContainer>
                    <ThankYouTitle variant="h4">Thank you!</ThankYouTitle>
                    <ImageContainer>
                        <ProjectImage src={ProjectStart} alt="Project Start" />
                    </ImageContainer>
                    <BodyText variant="body1">
                        Your project '<strong>{projectName}</strong>' is all set
                        thanks for giving us a fuller picture of your project's
                        needs.
                    </BodyText>
                    <BodyText variant="body1">
                        <strong>Up next:</strong> Check out your main board and
                        start delegate "Requests". We've used the info you
                        shared to build your project a customised Beehive setup
                        experience.
                    </BodyText>
                </HeaderContainer>
                <ButtonContentBox>
                    <StyledButton
                        variant="contained"
                        fullWidth
                        onMouseEnter={() => setStartIsHovered(true)}
                        onMouseLeave={() => setStartIsHovered(false)}
                        onClick={() => {
                            window.location.href = '/overview';
                        }}
                    >
                        <ButtonTextBox $isHovered={isStartHovered}>
                            Let's start
                        </ButtonTextBox>
                        <ButtonIconBox $isHovered={isStartHovered}>
                            🐝
                        </ButtonIconBox>
                    </StyledButton>
                </ButtonContentBox>
            </ContentContainer>
        </ServicesCard>
    );
};

export default Thankyou;
